'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../index.js';
const selectedClassName = (option, selectedOption) => option !== selectedOption
    ? 'cursor-pointer px-1.5'
    : 'cursor-pointer px-1.5 text-pill-color rounded-md bg-pill-background-color';
const IconSelect = ({ icon, options, selectedOption, setSelectedOption, }) => (_jsx("div", { className: 'flex flex-row', children: options.map((option) => (_jsx("div", { className: selectedClassName(option, selectedOption), onClick: () => setSelectedOption(option), children: _jsx(Icon, { type: "light", icon: icon(option), size: '1x' }) }, `scheme-${option}`))) }));
export default IconSelect;
